import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 9EB832F8-B389-47AA-ADDA-A2163E75DC20
 * name alpha-c-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaCBoxOutlineIcon = createSvgIcon(<><path d="M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M5,5V19H19V5H5M11,7H13A2,2 0 0,1 15,9V10H13V9H11V15H13V14H15V15A2,2 0 0,1 13,17H11A2,2 0 0,1 9,15V9A2,2 0 0,1 11,7Z" /></>, 'AlphaCBoxOutlineIcon');
export default AlphaCBoxOutlineIcon